<div class="one-shell" [class.sidebar-collapsed]="sidebarCollapsed" [class.mobile-menu-open]="mobileMenuOpen">

    <aside class="one-sidebar">

   <div class="sidebar-brand">

    <a class="brand-link" routerLink="/dashboard">

        <div class="brand-logo">
            <img src="/logo/logo2.png" alt="ANAMETA" />
        </div>

        <div class="brand-copy">
            <strong>ANAMETA</strong>
            <span>ONE</span>
        </div>

    </a>

    <a
        class="sidebar-home-button"
        routerLink="/"
        aria-label="Anasayfa"
        title="Anasayfa">

        <i class="bi bi-house-door"></i>

    </a>

    <button
        type="button"
        class="sidebar-collapse-button d-none d-xl-flex"
        (click)="ToggleSidebar()">

        <i
            class="bi"
            [class.bi-chevron-left]="!sidebarCollapsed"
            [class.bi-chevron-right]="sidebarCollapsed">
        </i>

    </button>

</div>
        <div class="sidebar-divider"></div>

        <nav class="sidebar-menu">

            <div class="menu-section">

                <span class="menu-section-title">ANA MENÜ</span>

                <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <span class="menu-icon">
                        <i class="bi bi-grid-1x2-fill"></i>
                    </span>

                    <span class="menu-text">Dashboard</span>
                </a>

                <a routerLink="/marketplace" routerLinkActive="active">
                    <span class="menu-icon">
                        <i class="bi bi-shop-window"></i>
                    </span>

                    <span class="menu-text">Market</span>
                </a>

            

            </div>


              <div class="menu-section">

                <span class="menu-section-title">Projeler</span>

            
                <a routerLink="/createproject">
                    <span class="menu-icon">
                        <i class="bi bi-kanban-fill"></i>
                    </span>

                    <span class="menu-text">Proje Oluştur</span>
                </a>

             
                <a routerLink="/projectlist">
                    <span class="menu-icon">
                        <i class="bi bi-kanban-fill"></i>
                    </span>

                    <span class="menu-text">Projelerim</span>
                </a>


            </div>

            <div class="menu-section">

                <span class="menu-section-title">YÖNETİM</span>

                <a routerLink="/company" routerLinkActive="active">
                    <span class="menu-icon">
                        <i class="bi bi-buildings-fill"></i>
                    </span>

                    <span class="menu-text">Şirket</span>
                </a>

                <a routerLink="/team" routerLinkActive="active">
                    <span class="menu-icon">
                        <i class="bi bi-people-fill"></i>
                    </span>

                    <span class="menu-text">Ekip</span>
                </a>

                <a routerLink="/billing" routerLinkActive="active">
                    <span class="menu-icon">
                        <i class="bi bi-credit-card-fill"></i>
                    </span>

                    <span class="menu-text">Faturalandırma</span>
                </a>

            </div>

        </nav>

        <div class="sidebar-bottom">

            <nav class="sidebar-menu bottom-menu">

                <a routerLink="/support" routerLinkActive="active">
                    <span class="menu-icon">
                        <i class="bi bi-headset"></i>
                    </span>

                    <span class="menu-text">Destek</span>
                </a>

                <a routerLink="/settings" routerLinkActive="active">
                    <span class="menu-icon">
                        <i class="bi bi-gear-fill"></i>
                    </span>

                    <span class="menu-text">Ayarlar</span>
                </a>

            </nav>


        </div>

    </aside>

    <div class="mobile-overlay" (click)="CloseMobileMenu()"></div>

    <div class="one-workspace">

        <header class="one-header">

            <div class="header-left">

                <button type="button" class="mobile-menu-button d-xl-none" (click)="ToggleMobileMenu()">
                    <i class="bi bi-list"></i>
                </button>

                <div class="header-title">

                    <span>ANAMETA ONE</span>

                    <strong>
                        Dashboard
                    </strong>

                </div>

            </div>

            <div class="header-center">

                <div class="global-search">

                    <i class="bi bi-search"></i>

                    <input type="text" placeholder="Uygulama, proje veya hizmet ara..." />

                    <span class="search-shortcut">
                        CTRL K
                    </span>

                </div>

            </div>

            <div class="header-actions">

                <button type="button" class="header-action-button" title="Marketplace">
                    <i class="bi bi-bag"></i>
                </button>

                <button type="button" class="header-action-button notification-button" title="Bildirimler">
                    <i class="bi bi-bell"></i>

                    <span class="notification-dot"></span>
                </button>

                <div class="header-separator"></div>

          <div class="header-profile-wrapper">

    <button type="button"
            class="header-profile"
            [class.active]="isUserMenuOpen"
            (click)="toggleUserMenu(); $event.stopPropagation()">

        <div class="profile-avatar">
            GS
        </div>

        <div class="profile-info">
            <strong>Gökçen Sular</strong>
            <span>ANAMETA</span>
        </div>

        <i class="bi"
           [class.bi-chevron-down]="!isUserMenuOpen"
           [class.bi-chevron-up]="isUserMenuOpen">
        </i>

    </button>

    <div class="header-profile-menu"
         *ngIf="isUserMenuOpen"
         (click)="$event.stopPropagation()">

        <div class="profile-menu-header">
            <div class="profile-menu-avatar">
                GS
            </div>

            <div class="profile-menu-user">
                <strong>Gökçen Sular</strong>
                <span>{{ userName }}</span>
            </div>
        </div>

        <div class="profile-menu-divider"></div>

        <a routerLink="/profile"
           class="profile-menu-item"
           (click)="closeUserMenu()">

            <i class="bi bi-person"></i>

            <span>Profilim</span>

        </a>

        <a routerLink="/company"
           class="profile-menu-item"
           (click)="closeUserMenu()">

            <i class="bi bi-buildings"></i>

            <span>Şirket</span>

        </a>

        <a routerLink="/settings"
           class="profile-menu-item"
           (click)="closeUserMenu()">

            <i class="bi bi-gear"></i>

            <span>Ayarlar</span>

        </a>

        <div class="profile-menu-divider"></div>

        <button type="button"
                class="profile-menu-item profile-menu-logout"
                (click)="logout()">

            <i class="bi bi-box-arrow-right"></i>

            <span>Çıkış Yap</span>

        </button>

    </div>

</div>

            </div>

        </header>

        <main class="one-content">
            <router-outlet></router-outlet>
        </main>



    </div>

      

</div>


       <app-public-footer-layout></app-public-footer-layout>